// Business calendar dates follow Thailand; audit/Stripe timestamps stay UTC.
const formatter=new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Bangkok',calendar:'gregory',numberingSystem:'latn',year:'numeric',month:'2-digit',day:'2-digit'});
export function thaiDate(value:Date=new Date()):string{
 const parts=Object.fromEntries(formatter.formatToParts(value).map(part=>[part.type,part.value]));
 return `${parts.year}-${parts.month}-${parts.day}`;
}
export function thaiDateAfter(days:number,value:Date=new Date()):string{
 if(!Number.isSafeInteger(days))throw new RangeError('Calendar offset must be an integer');
 const date=new Date(thaiDate(value)+'T00:00:00.000Z');date.setUTCDate(date.getUTCDate()+days);
 return date.toISOString().slice(0,10);
}
